import classNames from 'classnames';
import React, { MouseEventHandler } from 'react';

const LikeIcon = ({ onClick, className }: { className?: string; onClick?: MouseEventHandler<SVGSVGElement> }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='#FFCA28'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      className={classNames('cursor-pointer active:scale-95', className)}
      onClick={onClick}
    >
      <path
        fill='#FFCA28'
        d='M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z'
      />
      <path fill='#FFCA28' d='M7 10v12' />
    </svg>
  );
};

export default LikeIcon;
